import { Label } from './ui/label'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select'

export type DepositRiskThresholdValue = 'CRITICAL' | 'HIGH' | 'MEDIUM' | 'LOW' | 'VERY_LOW'

export const DEPOSIT_RISK_THRESHOLD_OPTIONS: {
  value: DepositRiskThresholdValue
  label: string
}[] = [
  { value: 'CRITICAL', label: 'Critical' },
  { value: 'HIGH', label: 'High' },
  { value: 'MEDIUM', label: 'Medium' },
  { value: 'LOW', label: 'Low' },
  { value: 'VERY_LOW', label: 'Very Low' },
]

interface DepositRiskThresholdSelectProps {
  id?: string
  label?: string
  value: DepositRiskThresholdValue
  onValueChange: (value: DepositRiskThresholdValue) => void
  disabled?: boolean
  helperText?: string
}

export function DepositRiskThresholdSelect({
  id = 'deposit-risk-threshold',
  label = 'Deposit risk threshold',
  value,
  onValueChange,
  disabled = false,
  helperText,
}: DepositRiskThresholdSelectProps) {
  return (
    <div className="grid gap-2">
      <Label htmlFor={id}>{label}</Label>
      <Select value={value} onValueChange={onValueChange} disabled={disabled}>
        <SelectTrigger id={id}>
          <SelectValue placeholder="Select risk threshold" />
        </SelectTrigger>
        <SelectContent>
          {DEPOSIT_RISK_THRESHOLD_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {helperText ? <p className="text-xs text-muted-foreground">{helperText}</p> : null}
    </div>
  )
}
